export default __webpack_public_path__ + "82052c6d0b35bff600d6f19beabb4fc4.png";